import { Model } from '../../interfaces/pages/creative'

export type Type = Model & { error?: string }

export const initial: Type = {
  loading: true,
  making: false,
  creative: null,
}
